// extracted by mini-css-extract-plugin
export default {"root":"dIcwgUZBzTH3AER48GON"};